import MaintenancePage from "../MaintenancePage";
import Resource from "features/maintenance/resources/taxScheduleResource";

export default function TaxSchedule() {
    return <MaintenancePage resource={Resource} />;
}
